export const leveningStr = (data: string, amount: number): string => {
  let words: any = data.split(/<\/?\w*>/);
  words = words.reduce((data: string, one: string) => data += one);
  words = words.substr(0, amount);
  return words;
}
